import React from "react";
import { CircularProgress, Typography } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import api from "../common/api";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import CustomToolbar from "../common/AddButton";
import GridActions from "../common/GridActions";

import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Backdrop from "@material-ui/core/Backdrop";
import CuitVerification from "../vouchers/CuitVerification";
import GoogleMapsSearchBoxStandalone from "../common/work-orders/GoogleMapsSearchBoxStandalone";

class Providers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      lat: 0,
      lng: 0,
      isLoading: false,
      backdrop: false,
      menu: {
        open: false,
        anchorEl: ""
      },
      cuit_dialog: { open: false, contact_id: "" },
      serverSideFilterList: [],
      provider_types: [],
      filters: [[], [], [], [], [], [], [], [], [], [], [], [], [], []],
      contact_id: 0,
      orderColumn: "",
      orderOrder: "",
      rowId: 0,
      q_rows: 10
    };
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleRestore = this.handleRestore.bind(this);
  }

  async componentDidMount() {
    await this.getProviderTypes();
    this.changePage(
      1,
      this.state.filters,
      this.state.orderColumn,
      this.state.orderOrder,
      this.state.q_rows
    );
  }

  handleMapChange = location => {
    const lat = location.lat();
    const lng = location.lng();

    this.setState({ lat: lat, lng: lng });
  };
  getProviderTypes = () => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.provider_types, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({
          provider_types: res.data
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  sort = (column, order) => {
    let temp = {};
    temp.column = column;
    temp.order = order;

    this.setState({ orderColumn: column, orderOrder: order });
    this.changePage(
      this.state.page,
      this.state.filters,
      column,
      order,
      this.state.q_rows
    );
  };

  changePage = (page, filterList, column, order, q_rows) => {
    this.setState({
      isLoading: true
    });
    var q = "";
    var provider_type = "";
    var hansa_code = "";
    var deleted_at = 0;
    if (filterList[3].length !== 0) {
      q = filterList[3][0];
    }

    if (filterList[4].length !== 0) {
      q = filterList[4][0];
    }
    if (filterList[5].length !== 0) {
      provider_type = filterList[5];
    }
    if (filterList[2].length !== 0) {
      hansa_code = filterList[2];
    }
    if (filterList[9].length !== 0) {
      if (filterList[9][0] === "Si") deleted_at = 1;
    }
    var orderColumn = column !== "" ? column : "";
    var orderOrder = order !== "" ? order : "";

    const token = localStorage.getItem("userToken");

    const lat = this.state.lat;
    const long = this.state.lng;
    var url = api
      .providers()
      .index(
        page,
        q,
        provider_type,
        orderColumn,
        orderOrder,
        q_rows,
        hansa_code,
        deleted_at,
        "",
        lat,
        long
      );

    if (filterList[10] && filterList[10].length > 0) {
      url += `&sap_code=${filterList[10][0]}`;
    }
    if (filterList[12] && filterList[12].length > 0) {
      url += `&is_sap_active=${filterList[12][0] === "Si" ? 1 : 0}`;
    }

    axios
      .get(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        this.setState({
          isLoading: false,
          page: res.data.current_page,
          data: res.data.data,
          count: res.data.total,
          rowsPerPage: res.data.per_page,
          serverSideFilterList: filterList,
          filters: filterList
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 0px 0px 0px",
            fontSize: "0.75rem",
            maxWidth: "10rem"
          }
        },
        MUIDataTable: {
          responsiveStacked: {
            overflow: "unset",
            overflowX: "unset"
          }
        }
      }
    });
  handleRestore(id) {
    const token = localStorage.getItem("userToken");
    var formData = new FormData();
    axios
      .post(api.providers().restore(id), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(res => {
        this.setState({
          message: "Proveedor rehabilitado con éxito!",
          dialogOpen: true
        });
        this.setState({ errors: false });
        this.setState({ delete_id: "" });
        this.setState({ rowId: "" });
      })
      .catch(err => {
        this.setState({ errors: true, dialogOpen: true });
        this.setState({ delete_id: "" });
        this.setState({
          message:
            "Ha ocurrido un error al rehabilitar el proveedor, contacte a su administrador."
        });
      });
  }
  handleDelete(id) {
    this.setState({ delete_id: id });
    var provider = "";
    id = this.state.contact_id;
    this.state.data.map((val, idx) => {
      if (val.contact.id === id) {
        provider = val.fantasy_name;
        this.setState({ delete_id: val.id });
      }
    });
    var message = "";
    if (provider !== "") {
      message =
        "Está a punto de dar de baja al proveedor " +
        provider +
        ". ¿Está seguro?";
    } else {
      this.setState({ errors: true });
      message = "Hubo un problema al dar de baja al proveedor.";
    }
    this.setState({ message: message, dialogOpen: true });
  }

  /*  handleDelete(e){
    var provider = ''
    this.state.data.map((val, idx)=>{
      console.log('rowId  ')
        if(val.id === this.state.rowId){
          provider = val.fantasy_name
          this.setState({delete_id: val.id})
        }
    })
    var message = ''
    if (provider !==''){
        message = 'Está a punto de dar de baja al proveedor '+provider+'. ¿Está seguro?'
    } else {
        message = 'Hubo un problema al dar de baja al proveedor.'
    }
    this.setState({message: message, dialogOpen: true })
  }
*/
  handleRefresh(e) {
    e.preventDefault();
    window.location.href = `/providers`;
  }

  handleDialogClose(e) {
    e.preventDefault();
    this.setState({
      dialogOpen: false,
      errors: false,
      message: "",
      delete_id: ""
    });
  }

  handleCuitDialog = (e, contact_id) => {
    e.preventDefault();
    var cuit_dialog = this.state.cuit_dialog;
    cuit_dialog.open = !cuit_dialog.open;
    cuit_dialog.contact_id = contact_id;
    this.setState({ cuit_dialog });
  };

  confirmDelete() {
    const token = localStorage.getItem("userToken");

    return axios
      .delete(
        api.providers().delete(this.state.delete_id),
        { headers: { Authorization: `Bearer ${token}` } },
        { params: { "provider[id]": this.state.delete_id } }
      )
      .then(res => {
        this.setState({ message: "Proveedor dado de baja con éxito!" });
        this.setState({ errors: false });
        this.setState({ delete_id: "" });
        this.setState({ rowId: "" });
      })
      .catch(err => {
        this.setState({ errors: true });
        this.setState({ delete_id: "" });
        this.setState({ message: err.response.data.errors["provider.id"] });
      });
  }

  handleMenuClick(event, id) {
    var menu = {};
    menu.open = true;
    menu.anchorEl = event.currentTarget;
    this.state.data.map((val, idx) => {
      if (val.id === id) {
        this.setState({ contact_id: val.contact.id });
      }
    });
    this.setState({ menu: menu, rowId: id });
  }

  handleMenuClose(event) {
    event.preventDefault();
    var menu = {};
    menu.open = false;
    menu.anchorEl = null;
    this.setState({ menu: menu });
  }

  handleFilterSubmit = (page, filterList) => () => {
    page = 0;
    this.setState({ page });
    this.changePage(
      page,
      filterList,
      this.state.orderColumn,
      this.state.orderOrder,
      this.state.q_rows
    );
  };

  handleDownload = () => {
    const token = localStorage.getItem("userToken");
    var formData = new FormData();
    var filterList = this.state.filters;
    if (filterList[12] && filterList[12].length > 0) {
      formData.append("is_sap_active", filterList[12][0] === "Si" ? 1 : 0);
    }

    axios
      .post(api.providers().export(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        this.handleCloseBackdrop();
        window.location.href = response.data;
      })
      .catch(error => {
        alert("Falló la descarga");
      });
  };

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  render() {
    var provider_types = [];
    this.state.provider_types.map(val => {
      provider_types.push(val.name);
    });

    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: false,
          display: true,
          sort: true,
          sortDirection:
            this.state.orderColumn === "id" ? this.state.orderOrder : null
        }
      },
      {
        name: "contact.id",
        options: {
          display: false,
          filter: false
        }
      },
      {
        name: "contact.hansa_code",
        label: "Cod. Hansa",
        options: {
          filter: true,
          filterType: "textField",
          filterList: this.state.filters[2],
          sort: false,
          display: true
        }
      },
      {
        name: "fantasy_name",
        label: "Nombre de fantasia",
        options: {
          filter: true,
          filterType: "textField",
          filterList: this.state.filters[3],
          sort: true,
          sortDirection:
            this.state.orderColumn === "fantasy_name"
              ? this.state.orderOrder
              : null
        }
      },
      {
        name: "business_name",
        label: "Razon social",
        options: {
          filter: true,
          filterType: "textField",
          filterList: this.state.filters[4],
          sort: true,
          sortDirection:
            this.state.orderColumn === "business_name"
              ? this.state.orderOrder
              : null
        }
      },
      {
        name: "types.0.type.name",
        label: "Tipo de proveedor",
        options: {
          filter: true,
          sort: false,
          filterType: "select",
          filterOptions: {
            names: provider_types
          },
          filterList: this.state.filters[5]
        }
      },
      {
        name: "contact.address.0.formattedAddress",
        label: "Dirección",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return value;
            /*if (value !== undefined && value !== ''){
            var address = (value.data !== undefined && value.data !== '') ? JSON.parse(value.data) : ''
            var formatted_address = ''
            if (address !== '' && typeof address !== undefined){
              formatted_address = address.formatted_address
            } 
            return(formatted_address)
          } else {
            return ''
          }*/
          }
        }
      },
      {
        name: "is_official",
        label: "Es oficial",
        options: {
          filter: false,
          sort: true,
          sortDirection:
            this.state.orderColumn === "is_official"
              ? this.state.orderOrder
              : null,
          customBodyRender: (value, tableMeta, updateValue) => {
            return value === 0 ? (
              ""
            ) : (
              <i
                className="material-icons text-primary"
                style={{ fontSize: "1.5rem" }}
              >
                check_circle
              </i>
            );
          }
        }
      },
      {
        name: "is_main_provider",
        label: "Es casa central",
        options: {
          filter: false,
          sort: true,
          sortDirection:
            this.state.orderColumn === "is_main_provider"
              ? this.state.orderOrder
              : null,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <div>{value === 1 ? "Si" : "No"}</div>;
          }
        }
      },
      {
        name: "deleted_at",
        label: "Dado de baja",
        options: {
          filter: true,
          filterType: "select",
          filterOptions: {
            names: ["Si", "No"]
          },
          sort: false,
          display: false,
          filterList: this.state.filters[9]
        }
      },
      {
        name: "sap_code",
        label: "Código SAP",
        options: {
          filter: true,
          filterType: "textField",
          filterList: this.state.filters[11],
          sort: false
        }
      },
      {
        name: "sap_dimension",
        label: "Dimensión SAP",
        options: {
          filter: false,
          sort: false,
          display: false
        }
      },
      {
        name: "sap_active",
        label: "SAP Activo",
        options: {
          filter: true,
          filterType: "select",
          filterOptions: {
            names: ["Si", "No"]
          },
          filterList: this.state.filters[12],
          sort: false,
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return value ? "Si" : "No";
          }
        }
      },
      {
        name: "actions",
        label: "Acciones",
        options: {
          filter: false,
          sort: false,
          setCellHeaderProps: value => {
            return {
              style: {
                textAlign: "center"
              }
            };
          },
          customBodyRender: (value, tableMeta, updateValue) => {
            var id = tableMeta.rowData[0];
            var contact_id = tableMeta.rowData[1];
            var deleted_at = tableMeta.rowData[9];
            if (
              deleted_at !== "" &&
              deleted_at !== undefined &&
              deleted_at !== null
            )
              return (
                <Button
                  variant="contained"
                  onClick={() => {
                    this.handleRestore(id);
                  }}
                >
                  Rehabilitar
                </Button>
              );
            return (
              <GridActions
                id={id}
                contact_id={contact_id}
                module="provider"
                actions={{
                  edit: { url: "provider/edit/" + id, action: "edit" },
                  view: { url: "provider/" + id + "/1", action: "view" },
                  audit: { url: "providers/audit/" + this.state.rowId },
                  subcontacts: { url: "subcontacts/" + this.state.contact_id },
                  cuit_verification: {}
                }}
                onDelete={this.handleDelete}
                cuitVerification={true}
                onCuitVerification={this.handleCuitDialog}
                onMenuClick={this.handleMenuClick}
                onMenuClose={this.handleMenuClose}
                open={this.state.menu.open}
                anchorEl={this.state.menu.anchorEl}
                hasMenu={true}
              />
            );
          }
        }
      }
    ];

    const { data, count, q_rows, isLoading } = this.state;
    const options = {
      filter: true,
      search: false,
      selectableRows: true,
      filterType: "dropdown",
      customToolbar: () => {
        return <CustomToolbar url="new" />;
      },
      responsive: "stacked",
      serverSide: true,
      onDownload: () => {
        this.setState({ backdrop: true });
        this.handleDownload();
        return false;
      },
      onFilterDialogOpen: () => {
        console.log("filter dialog opened");
      },
      onFilterDialogClose: () => {
        console.log("filter dialog closed");
      },
      onFilterChange: (column, filterList, type) => {
        if (type === "chip") {
          this.handleFilterSubmit(this.state.page, filterList)();
        }
      },
      customFilterDialogFooter: filterList => {
        return (
          <div style={{ marginTop: "40px" }}>
            {/*<GoogleMapsSearchBoxStandalone
              height="100px"
              fontSize="1rem"
              places={[]}
              disabled={false}
              zoom={15}
              onChange={this.handleMapChange}
              location={{}}
            />*/}

            <Button
              variant="contained"
              onClick={this.handleFilterSubmit(this.state.page, filterList)}
            >
              Aplicar
            </Button>
          </div>
        );
      },
      count: count,
      rowsPerPage: q_rows,
      onChangeRowsPerPage: numberOfRows => {
        this.setState({ isLoading: true, data: [], q_rows: numberOfRows });
        this.changePage(
          this.state.page,
          this.state.filters,
          this.state.orderColumn,
          this.state.orderOrder,
          numberOfRows
        );
      },
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }
        this.sort(changedColumn, order);
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ data: [] });
            this.changePage(
              tableState.page + 1,
              this.state.filters,
              this.state.orderColumn,
              this.state.orderOrder,
              this.state.q_rows
            );
            break;
          default:
            break;
        }
      },
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? (
            <CircularProgress />
          ) : (
            "No hay resultados"
          ),
          toolTip: "Ordenar",
          columnHeaderTooltip: column => `Ordenar para ${column.label}`
        },
        filter: {
          all: "Todos los resultados",
          title: "Tus filtros",
          reset: "Resetear"
        },
        toolbar: {
          search: "Buscar",
          downloadCsv: "Exportar XLS",
          print: "Imprimir",
          viewColumns: "Ver columnas",
          filterTable: "Filtros"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        }
      }
    };

    return (
      <Container fluid className="main-content-container px-4">
        <Row>
          <Col className="p-2">
            <div>
              <Dialog
                open={this.state.dialogOpen}
                onClose={e => this.handleDialogClose(e)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Baja de proveedor
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {this.state.message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {!this.state.errors ? (
                    this.state.rowId === "" ? (
                      <div>
                        <Button
                          onClick={e => this.handleRefresh(e)}
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          onClick={e => this.handleDialogClose(e)}
                          color="primary"
                          autoFocus
                        >
                          Cancelar
                        </Button>
                        <Button
                          onClick={this.confirmDelete.bind(this)}
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    )
                  ) : (
                    <div>
                      <Button
                        onClick={e => this.handleDialogClose(e)}
                        color="primary"
                      >
                        Continuar
                      </Button>
                    </div>
                  )}
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.cuit_dialog.open}
                maxWidth="xl"
                onClose={e => this.handleCuitDialog(e, "")}
                fullWidth={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle
                  id="alert-dialog-title"
                  onClose={e => this.handleCuitDialog(e, "")}
                >
                  Verificación CUIT
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <CuitVerification
                      contact_id={this.state.cuit_dialog.contact_id}
                      dialog={this.state.cuit_dialog}
                    />
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </div>
            <MuiThemeProvider theme={this.getMuiTheme()}>
              <Backdrop
                open={this.state.backdrop}
                onClick={this.handleCloseBackdrop}
                style={{ zIndex: 10000, color: "#3f51b5" }}
              >
                <CircularProgress color="inherit" />{" "}
                <Typography className="ml-2" variant="h5" color="primary">
                  Descargando...
                </Typography>
              </Backdrop>

              <MUIDataTable
                title={
                  <Typography variant="h6">
                    Lista de proveedores
                    {isLoading && (
                      <CircularProgress
                        size={24}
                        style={{ marginLeft: 15, position: "relative", top: 4 }}
                      />
                    )}
                  </Typography>
                }
                data={data}
                columns={columns}
                options={options}
              />
            </MuiThemeProvider>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Providers;
